/* eslint-disable react/prop-types */
import React from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";

import SocialLinks from "./SocialLinks";
import SectionLinks from "./SectionLinks";
import Newsletter from "./Newsletter";
import { Link } from "react-router-dom";
import { heightBottomNav } from "../../../../_utils/constraints";
import colors from "../../../../_theme/base/colors";
import siteData from "../../../../_data";
import ContactInfo from "../../../_pages/ContactUs/ContactInfo";
import useSmoothResponsiveFontSize from "./../../../../_hook/useSmoothResponsiveFontSize";

function FooterSection({ isFooterHome = true }) {
  const isMobileView = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const {
    palette: { footer1 },
  } = useTheme();
  const customfontsize = useSmoothResponsiveFontSize();

  return (
    <Box
      component="footer"
      id="site-footer-section"
      style={{
        position: "relative",
        padding: "0px",
        margin: "0px",
        boxSizing: "border-box",
        width: "100%",
        overflowX: "hidden",
        paddingBottom: isMobileView ? `${heightBottomNav}px` : "0px",
        boxShadow: "0px -8px 10px rgba(0, 0, 0, 0.1)",
        background: `linear-gradient(to top,${footer1.background.from}, ${footer1.background.to})`,
      }}
    >
      <Box
        componnent="div"
        style={{
          width: "100%",
          backgroundColor: "transparent",
        }}
      >
        {isFooterHome ? (
          <ResponsiveFooter footer1={footer1} customfontsize={customfontsize} />
        ) : null}

        <FooterBottom footer1={footer1} customfontsize={customfontsize} />
      </Box>
    </Box>
  );
}

const ResponsiveFooter = ({ footer1, customfontsize }) => {
  const borderColor = colors.grey[100];
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", lg: "row" },
      }}
      style={{
        borderTop: "2px solid",
        borderBottom: "2px solid",
        padding: "0px",
        borderColor,
        boxSizing: "border-box",
        width: "100%",
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", lg: "33%" },
          py: 3,
          px: 2,
          boxSizing: "border-box",
          display: "flex",
          alignItems: "start",
          justifyContent: "center",
          flexDirection: "column",
        }}
        style={{
          borderColor,
        }}
      >
        {/* First Component */}
        <>
          <ContactInfo footer1={footer1} customfontsize={customfontsize} />
          <SocialLinks customfontsize={customfontsize} />
        </>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          width: { xs: "100%", lg: "66%" },
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            width: { md: "50%", xs: "100%" },
            boxSizing: "border-box",
            py: 3,
            px: 2,
            borderRight: { md: "2px solid", lg: "2px solid" }, // Right border for md and lg screens
            borderLeft: { lg: "2px solid" }, // Left border for lg screens only
            borderTop: { xs: "2px solid", lg: "none" },
            display: "flex",
            alignItems: "start",
            justifyContent: "center",
          }}
          style={{
            borderColor,
          }}
        >
          {/* Second Component */}
          <SectionLinks customfontsize={customfontsize} />
        </Box>

        <Box
          sx={{
            width: { md: "50%", xs: "100%" },
            borderTop: { xs: "2px solid", lg: "none" },
            py: 3,
            px: 2,
            boxSizing: "border-box",
            display: "flex",
            alignItems: "start",
            justifyContent: "center",
          }}
          style={{
            borderColor,
          }}
        >
          {/* Third Component */}
          <Newsletter customfontsize={customfontsize} />
        </Box>
      </Box>
    </Box>
  );
};

export const FooterBottom = ({ footer1, customfontsize }) => {
  const year = new Date().getFullYear(); // Gets the current year
  const { palette } = useTheme();

  return (
    <Box
      sx={{
        textAlign: "center",

        py: 2,
        backgroundColor: "transparent",
        borderColor: palette.grey[300],
        boxSizing: "border-box",
      }}
    >
      <Link
        to={siteData.author.fabookLink}
        target="_blank"
        style={{
          textDecoration: "none", // Remove underline
        }}
      >
        <Typography
          variant="body2"
          color="dark"
          sx={{
            fontSize: `${customfontsize}px`,
            lineHeight: `${customfontsize * 1.5}px`, // Line height for anchor
            color: footer1.body,
            textDecoration: "none", // Remove underline
          }}
        >
          Copyright &copy; {year} {siteData.brand.name} by{" "}
          <Typography
            variant="span"
            sx={{
              color: footer1.heading, // Add hover effect for better user experience
              "&:hover": {
                fontWeight: "bold",
              },
            }}
          >
            {siteData.author.name}
          </Typography>
        </Typography>
      </Link>
    </Box>
  );
};

export default FooterSection;
